import React from "react";

// Public landing page shown at the base index route ("/").
// Requires no authentication and no API calls.
export default function ComingSoon() {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "100vh", padding: "2rem" }}
    >
      <h1 className="display-4 mb-3">Alltheyears</h1>
      <p className="lead text-muted mb-0">Coming Soon</p>
    </div>
  );
}
